import React from "react";

export const NotFoundPage = () => {
  return <>NotFoundPage</>;
};
